import React from 'react';

import { formatPrice } from 'utilities/money';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';

import Arrow from './assets/arrow.png';
import BubbleCheckIcon from './assets/bubble_check_icon.svg';
import CheckCircleIcon from './assets/check_circle_icon.svg';
import MagooshLogo from '@magoosh/assets/magoosh-logo-purple.png';
import TimesCircleIcon from './assets/times_circle_icon.svg';

export default ({ mapInCents }) => {
  return (
    <div className="d-flex flex-column gap-l">

      <SectionHeader
        reveal
        subtitle="Improve your score by 5 points or your money back."
        supertitle="We offer more"
        supertitleIcon={BubbleCheckIcon}
        title="Better scores. Better price. Guaranteed."
      >
        <SectionHeader.Left>
          <div className="d-flex flex-1 hidden-xs hidden-sm justify-content-end">
            <img
              alt="Arrow pointing down to Magoosh features"
              height="152px"
              src={Arrow}
              style={{ marginBottom: -80 }}
              width="191px"
            />
          </div>
        </SectionHeader.Left>
      </SectionHeader>

      <div className="align-items-lg-end d-flex flex-column flex-lg-row gap-l">
        <Card className="flex-1">
          <div><img alt="Magoosh logo" height="26px" src={MagooshLogo} width="116px" /></div>

          <div className="d-flex flex-column gap-s">
            <MagooshFeature>The only course with official GRE questions</MagooshFeature>
            <MagooshFeature>Get a Magoosh-trained AI tutor that works with you until you get it</MagooshFeature>
            <MagooshFeature>Video and text-based lessons to support multiple learning styles</MagooshFeature>
            <MagooshFeature>Download our mobile apps to practice on the go</MagooshFeature>
            <MagooshFeature>Starts at an affordable <strong>{formatPrice(mapInCents, 'usd', true)}</strong></MagooshFeature>
          </div>
        </Card>

        <div className="d-flex flex-1 flex-column gap-s">
          <div style={{ color: '#8D8D8D', fontSize: 18 }}>
            <strong>Other "Premium" Courses</strong>
          </div>

          <div className="d-flex flex-column gap-s">
            <CompetitorShortfall skewAngle={0.75}>No access to real GRE questions</CompetitorShortfall>
            <CompetitorShortfall skewAngle={-1.14}>No AI support to guide your studying</CompetitorShortfall>
            <CompetitorShortfall skewAngle={1.24}>Text-based explanations only</CompetitorShortfall>
            <CompetitorShortfall skewAngle={-1.48}>Not optimized for mobile</CompetitorShortfall>
            <CompetitorShortfall>Costs upwards of <strong>$500</strong></CompetitorShortfall>
          </div>
        </div>
      </div>
    </div>
  );
};

const CompetitorShortfall = (props) => {
  return (
    <div
      style={{
        // In order to use a border radius we need to use a different approach to a dashed
        // background. This approach only works with a white background so we can'pt use it
        // everywhere.
        background: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(to bottom, #CECECE) border-box',
        border: '1px dashed #fff',
        borderRadius: 12,
        overflow: 'hidden',
        transform: props.skewAngle ? `rotate(${props.skewAngle}deg)` : 'none'
      }}
    >
      <div
        className="align-items-center d-flex gap-s"
        style={{
          background: 'linear-gradient(90deg, #F5F5F5, #FFFFFF)',
          padding: 16
        }}
      >
        <img alt="X icon" height="20px" loading="lazy" src={TimesCircleIcon} width="20px" />
        <div>{props.children}</div>
      </div>
    </div>
  );
};

const MagooshFeature = (props) => {
  return (
    <div
      className="align-items-center d-flex gap-s"
      style={{ background: '#E9F7F1', borderRadius: 12, padding: 16 }}
    >
      <img alt="Checkmark icon" height="20px" loading="lazy" src={CheckCircleIcon} width="20px" />
      <div>{props.children}</div>
    </div>
  );
};
